import { App as CapApp } from '@capacitor/app';
import { SplashScreen } from '@capacitor/splash-screen';
import { StatusBar, Style } from '@capacitor/status-bar';
import { PushNotifications } from '@capacitor/push-notifications';
import { isNativePlatform } from './storageService';

let lastBackPressTime = 0;

/**
 * Initializes Native App features when running on iOS or Android.
 */
export const initNativeBridge = ({ onBackPress, onPushNotificationReceived } = {}) => {
  if (!isNativePlatform()) {
    return;
  }

  // 1. Hide Splash Screen after brief initialization
  setTimeout(() => {
    SplashScreen.hide().catch(err => console.warn('[NativeBridge] Splash hide err:', err));
  }, 500);

  // 2. Configure Status Bar
  try {
    StatusBar.setStyle({ style: Style.Dark }).catch(() => {});
    StatusBar.setBackgroundColor({ color: '#161922' }).catch(() => {});
  } catch (err) {
    console.warn('[NativeBridge] StatusBar err:', err);
  }

  // 3. Android Hardware Back Button Handling
  CapApp.addListener('backButton', ({ canGoBack }) => {
    if (typeof onBackPress === 'function') {
      const handled = onBackPress();
      if (handled) return;
    }

    // Default double-tap exit behavior
    const now = Date.now();
    if (now - lastBackPressTime < 2000) {
      CapApp.exitApp();
    } else {
      lastBackPressTime = now;
      if (window.toast) {
        window.toast('뒤로가기 버튼을 한 번 더 누르면 앱이 종료됩니다.');
      }
    }
  });

  // 4. Setup Push Notifications
  setupPushNotifications(onPushNotificationReceived);
};

const setupPushNotifications = async (onReceived) => {
  try {
    const permResult = await PushNotifications.requestPermissions();
    if (permResult.receive === 'granted') {
      await PushNotifications.register();
    }

    PushNotifications.addListener('registration', (token) => {
      console.log('[PushNotification] FCM/APNs Device Token:', token.value);
      localStorage.setItem('clou_fcm_token', token.value);
    });

    PushNotifications.addListener('registrationError', (error) => {
      console.warn('[PushNotification] Registration error:', error);
    });

    PushNotifications.addListener('pushNotificationReceived', (notification) => {
      console.log('[PushNotification] Received foreground:', notification);
      if (typeof onReceived === 'function') {
        onReceived(notification);
      }
    });

    PushNotifications.addListener('pushNotificationActionPerformed', (notification) => {
      console.log('[PushNotification] Action performed:', notification);
      // Handle deep linking or tab transition if needed
    });
  } catch (err) {
    console.warn('[NativeBridge] Push notifications setup error:', err);
  }
};
